/* eslint-disable max-len */

/**
 * cancellationTermsAndConditions
 *
 * @param {Object} [options={}]
 * @param {string} [options.refund_before_cut_off_time]
 * @param {string} [options.refund_after_cut_off_time]
 * @param {number} [options.cut_off_time_in_hours]
 * @param {string} [options.booking_type]
 * @param {string} [options.refund_fee_before_cut_off]
 * @param {string} [options.refund_fee_after_cut_off]
 * @returns {string}
 */

export default ({
  refund_before_cut_off_time,
  refund_after_cut_off_time,
  cut_off_time_in_hours,
  // booking_deposit,
  booking_type,
  refund_fee_before_cut_off,
  refund_fee_after_cut_off,
} = {}) => {
  const charges = ch =>
    booking_type === 'FEE_PER_GUEST'
      ? `$${parseFloat(ch).toFixed(2)} per guest`
      : `$${parseFloat(ch).toFixed(2)} per booking`;

  const cutOffTime = `${cut_off_time_in_hours}hr(s)`;

  const alternateMessage =
    cut_off_time_in_hours === 0 || cut_off_time_in_hours === '0';

  const rules = {
    refund_before_cut_off_time__FULL: {
      refund_after_cut_off_time__FULL: {
        message: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. This booking is eligible for a full refund before the scheduled booking time.\n 2. No refund will be processed for "No Shows".\n3. For any modification or changes to your booking please contact the venue.\n4. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n5. Any refund will be processed in the same method as the original payment.\n</span>
        `,
        alternateMessage: `      
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. This booking is eligible for a full refund before the scheduled booking time.\n 2. No refund will be processed for "No Shows".\n3. For any modification or changes to your booking please contact the venue.\n4. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n5. Any refund will be processed in the same method as the original payment.\n</span>
          `,
      },
      refund_after_cut_off_time__PARTIAL: {
        message: `	
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. Bookings canceled more than ${cutOffTime} prior to the scheduled booking time will be eligible for a full refund.\n2. if the booking is cancelled or changed within ${cutOffTime} of the scheduled booking time, a cancellation fee of ${charges(
          refund_fee_after_cut_off,
        )} will apply.\n3. No refund will be processed for "No Shows".\n4. For any modification or changes to your booking please contact the venue.\n5. We may contact you about this reservation, so please ensure your email and phone number are up to date\n6. Any refund will be processed in the same method as the original payment.</span>
        `,
        alternateMessage: ``,
      },
      refund_after_cut_off_time__NO_REFUND: {
        message: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. Bookings canceled more than ${cutOffTime} prior to the scheduled booking time will be eligible for a full refund.\n2. No refund will be processed if the booking is cancelled or changed within ${cutOffTime} of the scheduled booking time.\n3. No refund will be processed for "No Shows".\n4. For any modification or changes to your booking please contact the venue.\n5. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n6. Any refund will be processed in the same method as the original payment.\n</span>
        `,
        alternateMessage: ``,
      },
    },
    refund_before_cut_off_time__PARTIAL: {
      refund_after_cut_off_time__PARTIAL: {
        message: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. Bookings canceled more than ${cutOffTime} prior to the scheduled booking time, a cancellation fee of ${charges(
          refund_fee_before_cut_off,
        )} will apply.\n2. If the booking is cancelled or changed within ${cutOffTime} of the scheduled booking time, a cancellation fee of ${charges(
          refund_fee_after_cut_off,
        )} will apply.\n3. No refund will be processed for "No Shows".\n4. For any modification or changes to your booking please contact the venue.\n5. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n6. Any refund will be processed in the same method as the original payment.\n</span>
        `,
        alternateMessage: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. Bookings canceled before the scheduled booking time, a cancellation fee of ${charges(
          refund_fee_after_cut_off,
        )} will apply.\n2. No refund will be processed for "No Shows".\n3. For any modification or changes to your booking please contact the venue.\n4. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n5. Any refund will be processed in the same method as the original payment.\n</span>
        `,
      },
      refund_after_cut_off_time__NO_REFUND: {
        message: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. Bookings canceled more than ${cutOffTime} prior to the scheduled booking time, a cancellation fee of ${charges(
          refund_fee_before_cut_off,
        )} will apply.\n2. No refund will be processed if the booking is cancelled or changed within ${cutOffTime}of the scheduled booking time.\n3. No refund will be processed for "No Shows".\n4. For any modification or changes to your booking please contact the venue.\n5. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n6. Any refund will be processed in the same method as the original payment.\n</span>
        `,
        alternateMessage: ``,
      },
    },
    refund_before_cut_off_time__NO_REFUND: {
      refund_after_cut_off_time__NO_REFUND: {
        message: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. This booking is not eligible for a refund for any cancellation or changes.\n2. No refund will be processed for "No Shows".\n3. For any modification or changes to your booking please contact the venue.\n4. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n5. Any refund will be processed in the same method as the original payment.\n</span>
        `,
        alternateMessage: `
        <span style="font-size: 14.4px; white-space-collapse: preserve;">1. This booking is not eligible for a refund for any cancellation or changes.\n2. No refund will be processed for "No Shows".\n3. For any modification or changes to your booking please contact the venue.\n4. We may contact you about this reservation, so please ensure your email and phone number are up to date.\n5. Any refund will be processed in the same method as the original payment.\n</span>
        `,
      },
    },
  };

  const temp =
    rules[`refund_before_cut_off_time__${refund_before_cut_off_time}`]?.[
      `refund_after_cut_off_time__${refund_after_cut_off_time}`
    ];

  if (temp) {
    return alternateMessage ? temp.alternateMessage : temp.message;
  }

  return '';
};
